import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/product';
import React from 'react';
// pageContainer
import ProductList from '_pageContainers/product/list';
import ProductItem from './ProductItem';
import ProductBreadCrumb from './ProductBreadCrumb';
import Filter from 'theme/product/list/Filter';
import Sorter from 'theme/product/list/Sorter';
import Icon from 'theme/Icon';
import Error from 'theme/Error';
import Button from 'theme/Button';
import Pagination from 'theme/Pagination';
import ModalSpinner from 'theme/ModalSpinner';
import { parameterizedString } from 'theme/utils';
import { setSelectedCategory } from 'actions/navigation';

import './style.less';

const productListGrid = (pageContext) => {
  const {
    props: {
      products,
      facets,
      facetsApplied,
      sorters,
      pending,
      pagination,
      error,
      selectedCategory,
    },
    overlay,
    triggerOverlay,
    setFilterHandler,
    setSorterHandler,
    emptyFilters,
    removeFilterHandler,
    setPageHandler,
  } = pageContext;

  const renderProducts = (products) => {
    return products.map((product) => {
      return <ProductItem product={product} key={product.pk} />;
    });
  };

  const renderFilters = (filters) => {
    return filters
      .filter((filter) => {
        return (
          filter.key !== 'category_ids' &&
          filter.key !== 'in_stock' &&
          filter.key !== 'price'
        );
      })
      .map((filter) => {
        return (
          <Filter
            title={filter.name}
            iconClosed='arti'
            iconOpened='oksag'
            choices={filter.data.choices}
            key={filter.search_key}
            overlay={(val) => triggerOverlay(val)}
            overlayVisible={overlay}
            applyFilterQuery={(filterValues) =>
              setFilterHandler(filter.search_key, filterValues)
            }
          />
        );
      });
  };

  const renderAppliedFilters = (facets) => {
    return facets.map((facet) => {
      return facet.data.choices
        .filter((choice) => {
          return choice.is_selected === true;
        })
        .map((choice, index) => {
          return (
            <Button
              classes='product-list__filter-applied'
              onClick={() =>
                removeFilterHandler(facet.search_key, choice.value)
              }
              key={index}
            >
              {facet.name}: {choice.label}
              <Icon icon='carpi' />
            </Button>
          );
        });
    });
  };

  return (
    <div className='product-list headerMargin'>
      <ProductBreadCrumb
        selectedCategory={selectedCategory}
        setSelectedCategory={(pk) => setSelectedCategory(pk)}
      />
      <div
        onClick={() => (overlay ? triggerOverlay(!overlay) : () => {})}
        className={`document ${overlay ? 'overlay-active' : ''}`}
      >
        {!pending && error.message && (
          <Error classes='text-center' message={$ST.ERROR_FIRST} />
        )}
        {facets && !error.message && (
          <div className='product-list__wrapper'>
            {!!facetsApplied.length && (
              <div className='product-list__filter-applieds'>
                <Button
                  classes='product-list__filter-remove pointer text-right'
                  onClick={() => emptyFilters()}
                >
                  {$ST.REMOVE_FILTERS}
                </Button>
                {facetsApplied.length > 0 &&
                  renderAppliedFilters(facetsApplied)}
              </div>
            )}
            {!!pagination.total_count && (
              <div className='filters'>
                {renderFilters(facets)}
                <Sorter
                  title={$ST.SORT}
                  iconClosed='arti'
                  iconOpened='oksag'
                  choices={sorters}
                  key='sorter'
                  applyFilterQuery={(filterValues) =>
                    setSorterHandler(filterValues)
                  }
                />
              </div>
            )}
            {!pending && (
              <div className='product-list__count text-center'>
                {parameterizedString($ST.FOUND_PRODUCT, pagination.total_count)}
              </div>
            )}
            <div className='product-list-items row'>
              {renderProducts(products)}
            </div>
            <Pagination
              pagination={pagination}
              onPaged={(page) => {
                setPageHandler(page);
              }}
            />
          </div>
        )}
        {pending && <ModalSpinner />}
      </div>
    </div>
  );
};

export default ProductList(productListGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/list/index.js